import { useEffect, useRef, useState } from 'react'

import { escribirRefresco, leerRefresco } from './calendario-refresco'

/** Recarga lo que la cabecera tiene abierto. Se calla si la pestaña no se ve. */
export function useRefrescoCalendario(recargar: () => void) {
    const [intervaloMs, setIntervaloMs] = useState(leerRefresco)
    // Si `recargar` cambia de identidad en cada fetch, reiniciar el
    // intervalo lo dejaba a cero una y otra vez (spec 015 · FR-030).
    const recargarRef = useRef(recargar)
    recargarRef.current = recargar

    function elegir(ms: number) {
        setIntervaloMs(ms)
        escribirRefresco(ms)
    }

    useEffect(() => {
        if (intervaloMs <= 0) return
        const id = setInterval(() => {
            if (document.hidden) return
            recargarRef.current()
        }, intervaloMs)
        return () => clearInterval(id)
    }, [intervaloMs])

    return { intervaloMs, elegir }
}
